import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import deepEqual from 'deep-equal';

//import defaultImg from './image-ph.png';

const sizes = {
	720: 538,
	1200: 958,
	1441: 1364,
};

const sizesExact = {
	...sizes,
	568: 314,
	1000: 706,
	1440: 1126,
};

const sizeNames = {
	314: 'mobile-small',
	538: 'mobile',
	706: 'tablet-small',
	958: 'tablet',
	1126: 'desktop-small',
	1364: 'desktop',
};

export default class ResponsiveImage extends Component {
	static propTypes = {
		browser: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.oneOf([false]),
		]).isRequired,
		img: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.string,
			PropTypes.oneOf([false]),
		]),
		alt: PropTypes.string,
		span: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object,
		]).isRequired,
		className: PropTypes.string,
		useExactBreakpoint: PropTypes.bool,
		style: PropTypes.object,
		renderToDiv: PropTypes.bool,
		onLoad: PropTypes.func,
	};

	static defaultProps = {
		browser: false,
		useExactBreakpoint: false,
		style: {},
		renderToDiv: false,
		className: '',
		onLoad: () => {},
	};

	constructor(props) {
		super(props);
		this.mounted = true;

		this.state = {
			broken: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (!deepEqual(nextProps.img, this.props.img)) {
			this.setState({
				clear: true,
			});

			setTimeout(() => {
				this.mounted && this.setState({
					clear: false,
				});
			}, 20);
		}
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let path = this.getPath();

		if (this.state.clear) {
			return false;
		}

		if (path && !this.state.broken) {
			if (!this.props.renderToDiv) {
				return (
					<img
						src={path}
						alt={this.getAltText()}
						className={this.props.className}
						style={this.props.style}
						onError={e => this.brokenImage(true, e)}
						onLoad={e => this.brokenImage(false, e)}
					/>
				);
			} else {
				let style = {
					...this.props.style,
					backgroundImage: `url(${path})`,
				};

				return (
					<div className={this.props.className} style={style}>
						{this.props.children}
					</div>
				);
			}
		}

		return false;
	}

	brokenImage(val, e) {
		if (this.state.broken !== val) {
			this.setState({
				...this.state,
				broken: val,
			});
		}

		this.props.onLoad(val, e);
	}

	getPath() {
		if (typeof this.props.img === 'string') {
			return this.props.img;
		}

		const resolution = this.getResolution();
		const span = this.getSpan();

		if (
			this.props.img &&
			this.props.img.hasOwnProperty(resolution) &&
			this.props.img[resolution].hasOwnProperty(span) &&
			this.props.img[resolution][span]
		) {
			return this.props.img[resolution][span];
		}

		return false;
	}

	getSpan() {
		if (typeof this.props.span === 'string') {
			if (this.props.span) {
				return this.props.span;
			}

			const res = Object.keys(this.props.img);
			const span = Object.keys(this.props.img[res[0]]);
			return span[span.length - 1];
		} else if (typeof this.props.span === 'object') {
			const breakpoint = sizeNames[this.getResolution()];

			// this.props.useExactBreakpoint && console.log(breakpoint);
			if (this.props.span.hasOwnProperty(breakpoint)) {
				return this.props.span[breakpoint];
			}
		}

		return 'span14';
	}

	getAltText() {
		return this.props.alt || '';
	}

	getResolution() {
		const browserWidth = (this.props.browser && this.props.browser.window) ? this.props.browser.window.width : 2000;
		const sizeArray = this.props.useExactBreakpoint ? sizesExact : sizes;
		const keys = Object.keys(sizeArray);
		for (var i = 0; i < keys.length; i++) {
			if (browserWidth < keys[i] || !keys.hasOwnProperty(i + 1)) {
				// this.props.useExactBreakpoint && console.log(`${browserWidth} < ${keys[i]}  >> ${sizeArray[keys[i]]}`);
				return sizeArray[keys[i]];
			}
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/image/image.js
 **/